import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Shield } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: 'admin' | 'doctor';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen gradient-pastel flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 gradient-primary rounded-full flex items-center justify-center mx-auto mb-4 shadow-soft animate-pulse">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <p className="text-luma-text-light">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has the required role
  if (user.role !== requiredRole) {
    console.log(`User role "${user.role}" doesn't match required role "${requiredRole}"`);
    
    // Redirect to their correct dashboard based on their actual role
    if (user.role === 'admin') {
      return <Navigate to="/admin" replace />;
    } else if (user.role === 'doctor') {
      return <Navigate to="/doctor" replace />;
    } else {
      // Unknown role - redirect to home
      return <Navigate to="/" replace />;
    }
  }

  // User is authenticated and has correct role
  return <>{children}</>;
};

export default ProtectedRoute;